import { AbTest, appMode, AppMode, appName, appVersion, Stage, Theme } from '@infinitro/config';
export { AbTest, appMode, AppMode, appName, appVersion, Stage, Theme };
// todo: deprecate these in favor of dynamic config
export const stage = (import.meta.env.VITE_STAGE ?? Stage.Stage);
export const abTest = (import.meta.env.VITE_AB_TEST ?? AbTest.A);
export const theme = (import.meta.env.VITE_THEME ?? Theme.Flush);
